import { gql } from '@common/hooks';
import { BillingCardFragment } from '@institutions/graphql';

const EffectiveBillingCardQuery = gql`
  query EffectiveBillingCard(
    $effectiveDate: ISO8601Date!
    $organizationUnitId: ID!
    $roleId: ID!
    $roleLevel: RoleLevelEnum!
  ) {
    effectiveBillingCard(
      effectiveDate: $effectiveDate
      organizationUnitId: $organizationUnitId
      roleId: $roleId
      roleLevel: $roleLevel
    ) {
      ...BillingCardFragment
    }
  }
  ${BillingCardFragment}
`;

export { EffectiveBillingCardQuery };
